/** Storage the persisted query cache is written to (values are JSON strings). */
export type CacheStorage = {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
  /** Removes every persisted query cache (all users, all orgs). */
  removeAll(): Promise<void>;
};

export const CACHE_KEY_PREFIX = "sc-query-cache:";
